import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";

import {
  NotifyNerve,
  deleteNervePost,
} from "../../redux/admin/actions/admin.actions";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { SyncOutlined } from "@ant-design/icons";
import { Table } from "react-bootstrap";
import style from "./Notify.module.scss";
import { PlusOutlined } from "@ant-design/icons";
import CreateForm from "./CreateForm";

const NotifyNerveScreen = () => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataItem, setDataItem] = useState({});
  const [createModal, setCreateModal] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [refId, setrefId] = useState("");

  const dispatch = useDispatch();
  const { notifyNerve } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(NotifyNerve());
    setLoading(false);
  }, [dispatch, dataUpdated]);

  const headers = [
    { key: "title", label: "Title" },
    { key: "message", label: "Message" },
    { key: "name", label: "Name" },
    {key: "remove", label: "Remove"}
  ];

  const handleSuccessPost = () => {
    // Perform your post logic here

    // Set dataUpdated to true to trigger data refresh
    setDataUpdated(true);
  };

  const handleRow = (item) => {
    const { ref_id, title, message, id } = item;
    const formData = {
      ref_id: ref_id,
      id: id,
      title: title,
      message: message,
    };
    setDataItem(formData);
    setrefId(ref_id);
    setModal(true);
  };
  return (
    <div>
      <div className={style.h2}>
      <p>Notify Nerve</p>
      </div>
      <div className="d-flex justify-content-between m-3">
        <div className={style.create} onClick={() => setCreateModal(true)}>
          Create <PlusOutlined />
        </div>
      </div>

      <section style={{ maxWidth: "90%", margin: "auto", boxShadow: "1px 2px 10px rgba(112, 144, 176, 0.25)"}}>
        {loading && <LinearLoader />}

        <Table borderless responsive className="" hover>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {notifyNerve?.map((item, index) => {
            return (
              <tbody>
                <tr className={style.TableBodyRow} key={index}>
                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.title}
                  </td>
                  <td
                    style={{
                      width: "20vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.message}
                  </td>

                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.name}
                  </td>

                  <td style={{ width: "15vw" }}>
                    <button
                      className={style.btnD}
                      onClick={() => handleRow(item)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </Table>
        <ConfirmationModal
          open={createModal}
          handleClose={() => setCreateModal(false)}
          closemodal={() => setCreateModal(false)}
          bgcolor="white"
          width="45vw"
          instruction={
            <CreateForm
              loading={loading}
              handleSuccessPost={handleSuccessPost}
              refId={refId}
              onClickYes={() => {}}
              setCreateModal={setCreateModal}
            />
          }
        />
        {modal && (
          <Modal
            setModal={setModal}
            dataItem={dataItem}
            handleSuccessPost={handleSuccessPost}
          />
        )}
      </section>
    </div>
  );
};

export default NotifyNerveScreen;

const Modal = ({ setModal, dataItem, handleSuccessPost }) => {
  // console.log("handlesuccesspost", handleSuccessPost);
  const dispatch = useDispatch();
  const { id } = dataItem;

  const [showSpinner, setShowSpinner] = useState(false);

  const handleYesButton = () => {
    // dispatch(notifyNervePost(dataItem));
    dispatch(deleteNervePost(id));
    setShowSpinner(true);
    setTimeout(() => {
      setShowSpinner(false);
      setModal(false);
      handleSuccessPost();
      // setIsDeleted(true)
    }, 1500);
  };
  const handleNoButton = () => {
    setModal(false);
  };
  const handleOverlayClick = () => {};
  return (
    <div className={style.overlay} onClick={handleOverlayClick}>
      <div className={style.modalContent}>
        <h4 className={style.headerModal}>Do you want to delete?</h4>
        <div className={style.btnContainer}>
          <button className={style.btn} onClick={handleYesButton}>
            {showSpinner ? <SyncOutlined spin /> : "Yes"}
          </button>
          <button className={style.btn} onClick={handleNoButton}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};
